import Vue from 'vue'
import * as types from '../mutation-types'

export default {
	[types.SET_BREADCRUMB_TO]: (state, breadcrumbTo) => {
		Vue.set(state, 'breadcrumbTo', breadcrumbTo)
	},
	[types.SET_CURRENT_GAME_PHASE]: (state, currentGamePhase) => {
		Vue.set(state, 'currentGamePhase', currentGamePhase)
	},
	[types.SET_LAST_EMOJI_CODE]: (state, lastEmojiCode) => {
		Vue.set(state, 'lastEmojiCode', lastEmojiCode)
	},

	[types.SET_GAME_CLIENT_CLOSE_REDIRECT_URL]: (state, gameClientCloseRedirectUrl) => {
		Vue.set(state, 'gameClientCloseRedirectUrl', gameClientCloseRedirectUrl);
	},

	[types.SET_NAVIGATION_GUARD_ENABLED]: (state, navigationGuardEnabled) => {
		Vue.set(state, 'navigationGuardEnabled', navigationGuardEnabled);
	},

	[types.SET_GAME_TYPE]: (state, gameType) => {
		Vue.set(state, 'gameType', gameType);
	},

	[types.SET_GAME_CLIENT_TYPE]: (state, gameClientType) => {
		Vue.set(state, 'gameClientType', gameClientType);
	},

	[types.SET_LANGUAGE]: (state, language) => {
		Vue.set(state, 'language', language);
	}
}
